import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function CeremonyCountdownTimer({ targetDate, showIcon = true, variant = 'default' }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Ensure targetDate is a valid Date object
    const targetDateObj = targetDate ? new Date(targetDate) : null;

    if (!targetDateObj || isNaN(targetDateObj.getTime())) {
      console.warn('CeremonyCountdownTimer: Invalid targetDate provided:', targetDate);
      return;
    }

    const targetTime = targetDateObj.getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetTime - now;
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  const timeBlocks = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds }
  ];

  return (
    <Box sx={{ textAlign: 'center', mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        {showIcon && <AccessTimeIcon sx={{ mr: 1, color: '#FFD700', fontSize: '1.5rem' }} />}
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
            Ceremony Starts In:
          </Typography>
      </Box>
      <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: 600, mx: 'auto' }}>
        {timeBlocks.map((block, index) => (
          <Grid item xs={3} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: 'center',
                bgcolor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: 2
              }}
            >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    fontSize: { xs: '1.8rem', sm: '2.2rem' }
                  }}
                >
                  {String(block.value).padStart(2, '0')}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'white',
                    opacity: 0.9,
                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                    fontSize: '0.7rem',
                    textTransform: 'uppercase',
                    letterSpacing: 1
                  }}
                >
                  {block.label}
                </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="h6"
          sx={{ mt: 2, color: 'white', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}
      >
        December 13, 2025
      </Typography>
      <Typography
        variant="body1"
          sx={{ mt: 1, color: 'white', textShadow: '1px 1px 2px rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}
      >
        📍 Main Auditorium, University of Lagos, Akoka, Lagos, Nigeria
      </Typography>
    </Box>
  );
}

export default CeremonyCountdownTimer;
